"use client";

import { useEffect, useState } from "react";
import FooterComponent from "./Footer/Footer";
import Header from "./components/header/header";
import HomePage from "./home/homePage";
import urlList from "@/urlList";
import { notFound } from "next/navigation";

export default function Error() {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [allCategory, setAllCategory] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch blogs using relative path (Next.js rewrite will handle it)
        const blogsResponse = await fetch(
          `${urlList.GET_ALL_BLOGS}?page=0&size=999`
        );
        if (blogsResponse.ok) {
          const blogsData = await blogsResponse.json();

          setBlogs(blogsData?.data?.blogs || []);
        }

        // Fetch AOW filters using relative path
        const categoryResponse = await fetch(urlList.GET_AOW_FILTERS);
        if (categoryResponse.ok) {
          const categoryData = await categoryResponse.json();
          setAllCategory(categoryData?.data || []);
        }
      } catch (err) {
        console.error("Error fetching data in error page:", err);
        notFound();
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Header />

       <div className="mt-32 text-center px-4 py-8">
        <div className="bg-[#EFF6FC] border-l-4 border-[#3083c5] rounded-xl px-8 py-10 inline-block shadow-lg">
          <p className="text-lg font-bold text-[#3083c5] mb-2">
            404 - Insight Not Found
          </p>
          <p className="text-base font-medium text-[#707070] leading-relaxed">
            We couldn&apos;t find the requested insight. It may have been unpublished or the URL may be incorrect. Please explore other available insights below.
          </p>
        </div>
      </div>

      {!isLoading && (
        <HomePage blogs={blogs} isErrorPage={true} allCategory={allCategory} selectedAowId={null} />
      )}

      <FooterComponent />
    </div>
  );
}
